import { useMemo } from 'react'

import { get } from 'lodash'
import { useSelector, useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'

import whiteListsActions from '../actions/whiteList'

export const useWhiteLists = () => {
  const data = useSelector((state) => {
    return get(state, 'app.whiteListsManagement')
  })

  const dispatch = useDispatch()
  const actions = useMemo(
    () => bindActionCreators(whiteListsActions, dispatch),
    [dispatch],
  )

  return {
    actions,
    data,
  }
}
